/**
 * AJAX Cart Gift Wrap Enhancement - Simplified Variant Version
 * Adds variant pattern selection to drawer cart
 */

(function($) {
  'use strict';

  var AjaxCartGiftWrap = {
    // Configuration
    config: {
      wrapProductHandle: 'free-gift-wrapping',
      wrapVariants: [] // Populated from product fetch
    },

    init: function() {
      console.log('🎁 AJAX Cart Gift Wrap: Initializing...');
      // DISABLED: Variant selector in side cart
      // this.fetchWrapProduct(function() {
      //   this.bindEvents();
      //   this.processGiftWraps();
      //   console.log('🎁 AJAX Cart Gift Wrap: Ready');
      // }.bind(this));
    },

    fetchWrapProduct: function(callback) {
      var self = this;

      // Fetch the gift wrap product to get its variants
      $.getJSON('/products/' + this.config.wrapProductHandle + '.js', function(product) {
        console.log('🎁 Fetched gift wrap product with', product.variants.length, 'variants');
        self.config.wrapVariants = product.variants;
        callback();
      }).fail(function() {
        console.error('🎁 Could not fetch gift wrap product:', self.config.wrapProductHandle);
        callback();
      });
    },

    bindEvents: function() {
      var self = this;

      // Variant selection in drawer
      $(document).on('change', 'input[name^="ajax-wrap-variant"]', this.handleVariantChange.bind(this));

      // Listen for AJAX cart updates
      $(document).on('cart:updated ajaxCart.success cart.requestComplete', function() {
        setTimeout(function() {
          self.processGiftWraps();
        }, 500);
      });

      // Listen for cart open
      $(document).on('ajaxCart.open', function() {
        setTimeout(function() {
          self.processGiftWraps();
        }, 300);
      });

      // Listen for cart load complete
      $(document).on('ajaxCart.afterLoad', function() {
        setTimeout(function() {
          self.processGiftWraps();
        }, 200);
      });
    },

    processGiftWraps: function() {
      console.log('🎁 Processing gift wraps in drawer...');

      // Only add variant selectors (cleanup is handled by gift-wrap-cleanup.js)
      this.addVariantSelectors();
    },

    getCart: function(callback) {
      $.getJSON('/cart.js', callback);
    },

    isGiftWrapItem: function(title) {
      return title && (
        title.toLowerCase().includes('free gift wrap') ||
        title.toLowerCase().includes('gift wrapping')
      );
    },

    addVariantSelectors: function() {
      var self = this;

      // Skip if no variants loaded yet
      if (this.config.wrapVariants.length === 0) {
        console.log('🎁 No variants loaded yet');
        return;
      }

      // Find all gift wrap items in AJAX cart
      $('#ajax-cart__content .ajax-cart__product').each(function() {
        var $cartItem = $(this);
        var $title = $cartItem.find('.ajax-cart__product-title a');
        var itemTitle = $title.text().trim();

        // Check if this is a gift wrap item
        if (self.isGiftWrapItem(itemTitle)) {
          // Don't add selector if already exists
          if (!$cartItem.next('.ajax-gift-wrap-variants').length) {
            self.addVariantSelector($cartItem);
          }
        }
      });
    },

    addVariantSelector: function($cartItem) {
      var self = this;
      var cartKey = $cartItem.data('cart-item');
      var lineItem = $cartItem.data('line-item');

      // Get current variant from cart item data
      this.getCart(function(cart) {
        var currentWrap = cart.items.find(item => item.key === cartKey);
        if (!currentWrap) return;

        var currentVariantId = currentWrap.variant_id;

        // Build variant selector HTML
        var html = '<div class="gift-wrap-variants ajax-gift-wrap-variants" data-wrap-key="' + cartKey + '">';
        html += '<div class="gift-wrap-variants__title">Choose Your Gift Wrap:</div>';
        html += '<div class="gift-wrap-variants__options">';

        self.config.wrapVariants.forEach(function(variant, index) {
          var isSelected = variant.id === currentVariantId;
          var checkedAttr = isSelected ? 'checked' : '';

          html += '<label class="gift-wrap-variant-option ' + (isSelected ? 'selected' : '') + '" data-variant-id="' + variant.id + '">';
          html += '<input type="radio" ';
          html += 'name="ajax-wrap-variant-' + lineItem + '" ';
          html += 'value="' + variant.id + '" ';
          html += 'data-variant-title="' + variant.title + '" ';
          html += 'data-cart-key="' + cartKey + '" ';
          html += checkedAttr + '>';
          html += '<div class="gift-wrap-variant-visual">';

          // Use variant image or placeholder
          if (variant.featured_image && variant.featured_image.src) {
            html += '<img src="' + variant.featured_image.src + '" alt="' + variant.title + '" loading="lazy">';
          } else {
            html += '<span class="gift-wrap-placeholder">🎁</span>';
          }

          html += '</div>';
          html += '<span class="gift-wrap-variant-name">' + variant.title + '</span>';
          html += '</label>';
        });

        html += '</div>';
        html += '<div class="gift-wrap-variants__note">Click to change your gift wrap selection</div>';
        html += '</div>';

        // Insert after the gift wrap cart item
        $cartItem.after(html);
      });
    },

    handleVariantChange: function(e) {
      var $radio = $(e.currentTarget);
      var newVariantId = $radio.val();
      var newVariantTitle = $radio.data('variant-title');
      var oldCartKey = $radio.data('cart-key');

      console.log('🎁 Changing variant to:', newVariantTitle);

      // Visual feedback
      $radio.closest('.gift-wrap-variants__options')
        .find('.gift-wrap-variant-option').removeClass('selected');
      $radio.closest('.gift-wrap-variant-option').addClass('selected');

      // Get current wrap properties
      this.getCart(function(cart) {
        var currentWrap = cart.items.find(item => item.key === oldCartKey);

        if (!currentWrap) {
          console.error('🎁 Could not find gift wrap item');
          return;
        }

        var giftNote = currentWrap.properties && currentWrap.properties['Gift Note'] || '';
        var productName = currentWrap.properties && currentWrap.properties['Product Name'] || '';

        // Swap to new variant
        this.swapGiftWrapVariant(oldCartKey, newVariantId, giftNote, productName);
      }.bind(this));
    },

    swapGiftWrapVariant: function(oldCartKey, newVariantId, giftNote, productName) {
      var self = this;

      // Show loading state
      $('.ajax-gift-wrap-variants[data-wrap-key="' + oldCartKey + '"]')
        .addClass('loading')
        .append('<div style="text-align:center;padding:10px;color:#666;">Updating...</div>');

      // Step 1: Remove old gift wrap
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          id: oldCartKey,
          quantity: 0
        },
        dataType: 'json',
        success: function(cart) {
          console.log('🎁 Removed old wrap variant');

          // Step 2: Add new variant with preserved properties
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: {
              items: [{
                id: newVariantId,
                quantity: 1,
                properties: {
                  'Gift Note': giftNote,
                  'Product Name': productName
                }
              }]
            },
            dataType: 'json',
            success: function(item) {
              console.log('🎁 Added new variant:', newVariantId);

              // Refresh AJAX cart display
              self.refreshAjaxCart();
            },
            error: function(xhr) {
              console.error('🎁 Error adding new variant:', xhr);
              alert('Unable to change gift wrap. Please try again.');
              self.refreshAjaxCart();
            }
          });
        },
        error: function(xhr) {
          console.error('🎁 Error removing old wrap:', xhr);
          alert('Unable to update gift wrap. Please try again.');
          self.refreshAjaxCart();
        }
      });
    },

    refreshAjaxCart: function() {
      // Use theme's built-in refresh function
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
        window.PXUTheme.jsAjaxCart.updateView();
      } else {
        // Fallback: trigger custom event
        $(document).trigger('cart:updated');
      }
    }
  };

  // Initialize when DOM is ready
  $(document).ready(function() {
    AjaxCartGiftWrap.init();
  });

  // Re-initialize when cart is loaded
  $(document).on('cart:loaded ajaxCart.init', function() {
    setTimeout(function() {
      AjaxCartGiftWrap.init();
    }, 200);
  });

})(jQuery);
